// @flow

import { useFormikContext } from 'formik';
import React, { useContext } from 'react';

import { NATIVE_INFERENCE_POOL_REGION_BACKEND_NAME } from '../../../constants';
import { getDropdownOptions } from '../../stream-governance/utils';
import { SelectField } from '../../../formik-utils/FormFields';
import { NATIVE_INFERENCE_POOL_DETAILS_CONFIG_MAP } from '../../../configuration/native-inference-pool-details';
import { NativeInferencePoolContext } from '../../../contexts/NativeInferencePoolContext';
import { getFormattedRegionsUniverse } from '../../../common-utils/utils';
import { useRegionOptionsWithGovCloudDisabledIfRequired } from '../../../custom-hooks/useRegionOptionsWithGovCloudDisabledIfRequired';

export const NativeInferencePoolRegionsContainer = ({ disabled }) => {
  const { values } = useFormikContext();
  const nativeInferencePoolRegionsConfig = NATIVE_INFERENCE_POOL_DETAILS_CONFIG_MAP.get(
    NATIVE_INFERENCE_POOL_REGION_BACKEND_NAME
  );

  const nativeInferencePool = useContext(NativeInferencePoolContext);
  const dataUniverse = nativeInferencePool?.native_inference_configs?.region_details ?? [];

  const dataUniverseFormatted = getFormattedRegionsUniverse(dataUniverse);

  const nativeInferencePoolRegionOptions = getDropdownOptions(
    dataUniverseFormatted,
    values,
    nativeInferencePoolRegionsConfig,
    false,
    true,
    false,
    false,
    [],
    true
  );

  const regionOptionsWithGovCloudDisabledIfRequired =
    useRegionOptionsWithGovCloudDisabledIfRequired(nativeInferencePoolRegionOptions);

  return (
    <SelectField
      disabled={disabled}
      fieldDisplayName={nativeInferencePoolRegionsConfig.displayName}
      fieldName={nativeInferencePoolRegionsConfig.backendFieldName}
      options={regionOptionsWithGovCloudDisabledIfRequired}
      placeholder={null}
    />
  );
};
